export default __webpack_public_path__ + "static/media/telcel.1724edea.jpg";